import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentsSection, PageTitle } from "component/app/items";
import { Footer } from "component/elements/footer";
import { Header } from "component/elements/header";
import { CustomPopup, LoadingBox } from "component/basic/popup";
import { BtnBox, BtnItem } from "component/basic/btns";
import { CarListItem } from "component/product/car";
import { FixedPage, FixedSection } from "component/basic";
import { NotItems } from "component/basic/notItems";
import { CouponPackItem, FixedContents } from "component/product/page";
import { AlarmList, MypageBasicListItem, MypageContentsBox, MypageControll, PageContentsSection } from "component/mypage/items";

const Mypage = (props) => {
    const navigate = useNavigate();

    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(true);

    const mypageApi = useGet({
        url:`/mypage`,
        loginType:"login"
    });
    const mypageData = mypageApi?.data;

    const alarms = mypageData?.alarms;
    const reservations = mypageData?.reservations;
    const user_coupons = mypageData?.user_coupons;

    const [useCouponPopupData,setUseCouponPopupData] =  useState(null);

    useEffect(() => {
        setLoadingBoxOpen(false);
    }, []);

    return (
        <>
            <ContentsSection
                header={true}
                footer={true}
                addClass={"gBg"}
            >
                <Header
                    addClass=""
                    logo={false}
                    mMenu={false}
                    pageBack={true}
                    func={()=>{navigate(-1)}}
                    headTitle={"마이페이지"}
                    rightBtnsArr={null}
                    pageClose={false}
                    activeType={4}
                    closeFunc={()=>{}}
                />
                <FixedPage addClass="reverse mnReverse">
                    <FixedSection
                        pageBox="pageSizing"
                        boxAddClass="fixedsection_min"
                        addClass="nonFixed fixedsection_min"
                        contentsBox="fixedPage"
                        nonFixed={true}
                        headerChk={true}
                        footerChk={true}
                        minSize={961}
                    >
                        <MypageControll
                            addClass=""
                            data={mypageData}
                        />
                    </FixedSection>
                    <FixedContents>
                        <PageTitle
                            addClass="fixedContents_title multiTitle"
                            pageBack={null}
                            contents="쿠폰 내역"
                            linkFunc={()=>{navigate("/mypage/coupon")}}
                        />
                        <PageContentsSection addClass="mnpt">
                            {user_coupons && user_coupons?.length > 0 ?
                                <MypageContentsBox
                                    nPadding={true}
                                    title={null}
                                >
                                    {user_coupons && user_coupons?.map((item, i) => (
                                        <MypageBasicListItem
                                            key={i}
                                            type={"coupon"}
                                            status={item.status}
                                            image_url={item.image_url}
                                            coupon_type={item.coupon_type}
                                            discount_value={item.discount_value}
                                            discount_type={item.discount_type}
                                            company_name={item.company_name}
                                            name={item.name}
                                            use_condition={item.use_condition}
                                            use_condition_value={item.use_condition_value}
                                            end_date={item.end_date}
                                            func={()=>{
                                                setUseCouponPopupData({
                                                    addClass:"subTitle_line_1",
                                                    title:"제휴사 쿠폰 사용",
                                                    subTitle:"아래 바코드 이미지를 매장 직원분에게 보여주세요",
                                                    closeType:true,
                                                    closeFunc:(e) => {setUseCouponPopupData(null)},
                                                    closeBtnDel:true,
                                                    couponData:item
                                                });
                                            }}
                                        />
                                    ))}
                                </MypageContentsBox>
                                :
                                <NotItems addClass="minH" text={`쿠폰 내역이 없습니다.`}/>
                            }
                        </PageContentsSection>
                        <PageTitle
                            addClass="fixedContents_title multiTitle"
                            pageBack={null}
                            contents="예약 내역"
                            linkFunc={()=>{navigate("/reservation")}}
                        />
                        <PageContentsSection addClass="mnpt">
                            {reservations && reservations?.length > 0 ?
                                <>
                                    {reservations && reservations?.map((item, i) => (
                                        <CarListItem
                                            key={i}
                                            type="reservation"
                                            addClass=""
                                            id={item?.id}
                                            car_image={item?.image_url}
                                            maker={item?.maker}
                                            modelName={item?.name}
                                            passengerNum={item?.passenger_number}
                                            fuelType={item?.fuel}
                                            min_year={item?.min_year}
                                            max_year={item?.max_year}
                                            insuranceName={item?.insurance_name}

                                            carOptions={item?.options}

                                            status={item?.status}
                                            reservationId={item?.reservation_code}
                                            startDtm={item?.start_date}
                                            endDtm={item?.end_date}
                                            payment_price={item?.payment_price}
                                        />
                                    ))}
                                </>
                                :
                                <NotItems addClass="minH" text={`예약 내역이 없습니다.`}/>
                            }
                        </PageContentsSection>
                        <PageTitle
                            addClass="fixedContents_title multiTitle"
                            pageBack={null}
                            contents="알림"
                            linkFunc={()=>{navigate("/alarm")}}
                        />
                        <PageContentsSection addClass="mnpt">
                            {alarms && alarms?.length > 0 ? 
                                <MypageContentsBox
                                    nPadding={true}
                                    title={null}
                                >
                                    {alarms && alarms?.map((item, i) => (
                                        <AlarmList
                                            key={i}
                                            id={item?.id}
                                            title={item?.title}
                                            contents={item?.contents}
                                            link={item?.link}
                                            status={item?.status}
                                        />
                                    ))}
                                </MypageContentsBox>
                            :
                                <NotItems addClass="minH" text={`알림 내역이 없습니다.`}/>
                            }
                        </PageContentsSection>
                    </FixedContents>
                </FixedPage>
            </ContentsSection>
            <Footer/>
            <CustomPopup data={useCouponPopupData} toastType={true}>
                <CouponPackItem
                    addClass="useCouponPackItem"
                    name={useCouponPopupData?.couponData?.company_name}
                    couponImg={null}
                    barcode_image={useCouponPopupData?.couponData?.barcode_image}
                />
                <BtnBox
                    boxType="fixed"
                    addClass=""
                >
                    <BtnItem
                        addClass="subColor"
                        contents={"확인"}
                        disabled={false}
                        func={() => {
                            setUseCouponPopupData(null);
                        }}
                    />
                </BtnBox>
            </CustomPopup>
            <LoadingBox openType={loadingBoxOpen}/>
        </>
    );
};

export default Mypage;